import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { LogoIcon } from '../components/Logo';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

export default function EmailVerified({ setUser }) {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processVerification = () => {
      try {
        // Extract token and session from URL hash
        const hash = window.location.hash;
        const tokenMatch = hash.match(/token=([^&]+)/);
        const sessionMatch = hash.match(/session=([^&]+)/);

        if (tokenMatch) {
          const token = tokenMatch[1];
          
          // Decode the JWT to get user data
          try {
            const payload = JSON.parse(atob(token.split('.')[1]));
            const user = {
              user_id: payload.user_id,
              email: payload.email,
              full_name: payload.full_name,
              role: payload.role,
              company_id: payload.company_id,
              email_verified: true
            };

            // Store auth data
            localStorage.setItem('hrms_token', token);
            localStorage.setItem('hrms_user', JSON.stringify(user));

            if (setUser) {
              setUser(user);
            }

            // Clear the hash from URL
            window.history.replaceState(null, '', '/dashboard');

            // Show success and redirect
            toast.success('Email verified successfully! Welcome to MyHR Orbit!');
            navigate('/dashboard', { replace: true, state: { user } });
          } catch (e) {
            console.error('Failed to decode token:', e);
            toast.error('Verification failed - invalid token');
            navigate('/login');
          }
        } else {
          toast.error('Verification failed - no token found');
          navigate('/login');
        }
      } catch (error) {
        console.error('Email verification error:', error);
        toast.error('Verification failed');
        navigate('/login');
      }
    };

    processVerification();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950">
      <div className="text-center">
        <div className="flex items-center justify-center space-x-3 mb-6">
          <LogoIcon className="h-12 w-12" />
          <div className="flex items-baseline space-x-1">
            <span className="text-3xl font-bold text-white">MyHR</span>
            <span className="text-3xl font-bold text-emerald-400">Orbit</span>
          </div>
        </div>
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-400 mx-auto mb-4"></div>
        <p className="text-slate-400">Verifying your email...</p>
      </div>
    </div>
  );
}
